import RecipeSimpleDetail from "./RecipeSimpleDetail"
export default RecipeSimpleDetail
